import { render, staticRenderFns } from "./diolog.vue?vue&type=template&id=96049ba4&scoped=true"
import script from "./diolog.vue?vue&type=script&lang=js"
export * from "./diolog.vue?vue&type=script&lang=js"
import style0 from "./diolog.vue?vue&type=style&index=0&id=96049ba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96049ba4",
  null
  
)

export default component.exports